// @flow
import * as React from 'react';
import { Select } from 'grommet';
import { memoize } from 'lodash';
import { months } from 'moment';
import {
    MAX_TIMESTAMP,
    MIN_TIMESTAMP,
} from './DatePicker';


type Props = {
    value: number,
    onChange: (value: number) => void,
    dateValue: Date,
    minDate?: string,
    maxDate?: string,
};


class MonthPicker extends React.Component<Props> {
    months: Array<{[string]: string | number}>;

    static defaultProps = {
        minDate: new Date(MIN_TIMESTAMP),
        maxDate: new Date(MAX_TIMESTAMP),
    };

    constructor(props: Props) {
        super(props);
        this.months = months().map((name, i) => ({
            value: i,
            label: name,
        }));
        this.getValueOption = memoize(this.getValueOption);
    }

    handleChange = ({ option }: { option?: { value: number, label: string } }) => {
        const { onChange, value: propValue } = this.props;
        onChange(option ? option.value : propValue);
    };

    getValueOption = (value: number) => (
        this.months.find(({ value: monthValue }) => value === monthValue)
    );
    
    getDisabledOptions = () => {
        const { maxDate, minDate, dateValue } = this.props;
        let maxMonth = 11;
        let minMonth = 0;
        
        const max = new Date(maxDate);
        const min = new Date(minDate);
        if (dateValue.getFullYear() === max.getFullYear()) {
            maxMonth = max.getMonth();
        }
        
        if (dateValue.getFullYear() === min.getFullYear()) {
            minMonth = min.getMonth();
        }
        
        return this.months.filter((({ value }) => value < minMonth || value > maxMonth)).map(({ value }) => value);
    };

    render() {
        const {
            value,
        } = this.props;

        return (
            <Select
                options={this.months}
                disabled={this.getDisabledOptions()}
                value={this.getValueOption(value)}
                valueKey="value"
                labelKey="label"
                onChange={this.handleChange}
                plain
            />
        );
    }
}


export default MonthPicker;
